export default {
	FavouriteAdd: 'favourite_add',
	FavouriteRemove: 'favourite_remove',
	RegisterIncentiveClick: 'Register Incentive Click',
};
